<template>
	<div class="ReInputList">
		<h4 v-if="value.length==0">{{labelEmptyValue}}</h4>
		<el-checkbox-group v-model="CHB.masCHB">
		<div class="row cc-item" v-for="(objInput, obj_index) in value" :key="obj_index">
			<div class="fieldset col-md-9">
				<!--<base-checkbox v-if="bShowCHB" v-model="masCHB" ></base-checkbox>-->
				<el-checkbox v-if="bShowCHB && objInput.value!=''" :label="objInput.value"></el-checkbox>
				<base-radio v-if="bShowRB && objInput.value!=''" v-model="rb_default.value" :name="objInput.value"></base-radio>
				<base-input
					:disabled="objInput.label=='Другое'"
					:placeholder="placeholder"
					v-model="objInput.label"
				>
				</base-input>
			</div>
			<div class="btnGroup col-md-3">
				<button v-if="objInput.label != 'Другое'" class="ml-3 btn btn-icon btn-simple btn-danger" @click="del(obj_index)">
					<i class="tim-icons icon-trash-simple"></i>
				</button>
			</div>
		</div>
		</el-checkbox-group>
		<button class="btn btn-simple btn-primary" @click="addEmpty()">
			Добавить
		</button>
	</div>
</template>

<script>
	import { /*BaseCheckbox,*/ BaseRadio } from 'src/components/index';
	import { CheckboxGroup, Checkbox } from 'element-ui';
	export default {
		name: 'ReInputList',
		components: {
			BaseRadio,
			// BaseCheckbox,
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
		},
		props: {
			value: {
				type: Array,
				default(){return [{
					value: '',
					label: '',
				}];}
			},
			delMethod:{
				type: Object,
				default(){return {};}
			},
			placeholder: String,
			labelEmptyValue:{
				type: String,
				default: 'Пока пунктов, для списка причин "не целевой", нет'
			},
			required:{
				type: Boolean,
				default: false
			},
			findId: {
				type: String,
				default: '',
			},
			bShowRB:{
				type: Boolean,
				default: false
			},
			bShowCHB:{
				type: Boolean,
				default: false
			},
			rb_default: { // сделал так потому что надо менять значение переключателя и получать его значение в компоненте/странице родителе
				type: Object,
				default(){return {value:'-1'};},
			},
			CHB: { // сделал так потому что надо менять значение переключателя и получать его значение в компоненте/странице родителе
				type: Object,
				default(){return {masCHB:[]};},
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		methods: {
			addEmpty(){
				this.value.push({
					value: '',
					label: '',
				});
			},
			del(ind){
				if(this.value[ind].value != '' && this.value[ind].value != -1 && this.value[ind].value != '-1'){
					let apiParam = this.delMethod.apiParam;
					if(apiParam.obj == 'BP'){
						let bp_id = typeof this.$route.params.bp_id == 'undefined'?'':this.$route.params.bp_id;
						apiParam.flt.bp_id = bp_id;
						apiParam.flt.opt_id = this.value[ind].value;
					}
					this.$GVO.ApiCall(this.delMethod.apiMethod,apiParam)
						.then((objApi) => {  console.error(objApi);})
						.catch((errorObjApi) => {console.error(errorObjApi)});
				}
				this.value.splice(ind,1);
			},
		},
	}
</script>
<style scoped>
	.ReInputList .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.ReInputList .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	.ReInputList .fieldset > .form-check, .ReInputList .el-checkbox{width:50px;}
	/*.ReInputList .el-checkbox .el-checkbox__label{display:none;}
	.ReInputList .form-check-label{top: -18px;}*//* перенёс в _global.scss*/
	.ReInputList .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		margin-bottom: 15px;
	}
</style>
